import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import SecondaryHeader from '../../components/common/secondary header';
import Main from '../../layout/main';
import { b64DecodeUnicode, SyllabusService } from '../../services/competitions';
import { getMixpanelAdminType, Mixpanel } from '../../services/Mixpanel';
import "./style.scss";
import { textIdentifier } from '../../textIdentifier';

const ViewSyllabus = () => {

  const { selectedCompetition,lang } = useSelector(state => state.main);
  const { userData } = useSelector(state => state.auth);
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [previewPosition, setPreviewPosition] = useState({ x: 0, y: 0 });
  const [previewContent, setPreviewContent] = useState(null);
  const [isFetching, setIsFetching] = useState(true);

  const fetchSyllabus = async () => {
    try {
      const res = await SyllabusService(selectedCompetition.id);
      res.data.map((topic) =>
				topic.concepts.filter(concept => concept.question != null).map(
					(concept) => {
						concept.question.question = b64DecodeUnicode(
							concept.question.question
						)
						concept.question.answer_type = b64DecodeUnicode(
							concept.question.answer_type
						)
						// console.log(concept.question.answer_type,"ewfewfwef")
						return concept
					}
				)
			);
      setTopics(res.data);
			Mixpanel.track("Competition_Admin_Syllabus_Viewed", {
				"Admin_Type": getMixpanelAdminType(userData.groups),
				"CompetitionID": selectedCompetition.id,
				"CompetitionName": selectedCompetition.name
			});
			Mixpanel.people.set({
				"$email": userData.email,
				"$distinct_id": userData.id
			});
    } catch (error) {
      console.error("Error fetching syllabus: ", error);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    if (!selectedCompetition) {
      navigate(`/`);
    } else {
      fetchSyllabus();
    }
  }, []);

  const getClassName = (level) => {
    switch (level) {
      case "easy":
        return textIdentifier['chip-success'][lang];
      case "medium":
        return textIdentifier['chip-warning'][lang];
      case "hard":
        return textIdentifier['chip-danger'][lang];
      default:
        break;
    }
  };

  const calculatePreviewPosition = (rect) => {
    setPreviewPosition({
      // If (window's width - distance of hovered element from the right edge of the window) is
      // greater than the width of preview box(550px), then show the preview box on the
      // right side, otherwise on the left side.
      x:
        window.innerWidth - rect.right > 550
          ? rect.right - 30
          : rect.left - 550 + 30,
      // Similarly, for height: if (window's width - distance of hovered element from the bottom edge
      // of the window) is greater than the height of preview box(300), then show the preview box
      // on the bottom, otherwise on top.
      y:
        window.innerHeight - rect.bottom > 300
          ? rect.bottom - 10
          : rect.top - 300 + 10,
    });
  };

  let timeout = null;
  const handleMouseEnter = (e, concept) => {
    calculatePreviewPosition(e.target.getBoundingClientRect());
    timeout = setTimeout(() => {
      setShowPreview(true);
      setPreviewContent(concept);
    }, 200);
  };

  const handleMouseLeave = (e) => {
    setPreviewContent(null);
    setShowPreview(false);
    clearTimeout(timeout);
  };

	const viewQuestion = (previewContent) => {
		Mixpanel.track("Competition_Admin_Question_viewed", {
			"Admin_Type": getMixpanelAdminType(userData.groups),
			"CompetitionID": selectedCompetition.id,
			"CompetitionName": selectedCompetition.name,
			"Question_id": previewContent?.question?.id
		});
		Mixpanel.people.set({
			"$email": userData.email,
			"$distinct_id": userData.id
		});
		window.open(previewContent?.question?.link, "_blank");
	};

	const startTime = new Date(selectedCompetition?.start_time);
	const endTime = new Date(selectedCompetition?.end_time);

	if (isFetching) {
		return	<SecondaryHeader />
	}
  
  return (
		<>
			<SecondaryHeader />
			<Main className="view-syllabus">
				<div className="cr-wrapper-card">
					<div className="cr-card-header">
						<div className="header-container">
							<div className="cr-card-header justify-content-start">
								<div>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 35 35"
										fill="none"
									>
										<path
											fillRule="evenodd"
											clipRule="evenodd"
											d="M21.78 3.66699H10.2213C6.1933 3.66699 3.66797 6.51899 3.66797 10.555V21.4457C3.66797 25.4817 6.17997 28.3337 10.2213 28.3337H21.7786C25.82 28.3337 28.3346 25.4817 28.3346 21.4457V10.555C28.3346 6.51899 25.82 3.66699 21.78 3.66699Z"
											stroke="#2E2E2E"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M16 11V16.3333L20 20.3333"
											stroke="#2E2E2E"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
									<span>{textIdentifier['from'][lang]} :</span>
								</div>

								<div>
									<span>
										{startTime.getDate()}-{startTime.getMonth() + 1}-
										{startTime.getFullYear()}
									</span>
									<span style={{ color: "#0059b1" }}>
										{startTime.getHours() > 12
											? `${
													startTime.getHours() - 12
											  }:${startTime.getMinutes()}pm`
											: `${startTime.getHours()}:${startTime.getMinutes()}am`}
									</span>
									<span>to</span>
									<span>
										{endTime.getDate()}-{endTime.getMonth() + 1}-
										{endTime.getFullYear()}
									</span>
									<span style={{ color: "#0059b1" }}>
										{endTime.getHours() > 12
											? `${endTime.getHours() - 12}:${endTime.getMinutes()}pm`
											: `${endTime.getHours()}:${endTime.getMinutes()}am`}
									</span>
								</div>
							</div>
							<span>{selectedCompetition?.name}</span>
						</div>

						<Link
							to=""
							onClick={() =>
								window.open(window.location.origin + "/test-design", "_blank")
							}
						>
							<button className="btn-contained">
								<span>{textIdentifier['view-test-design'][lang]}</span>
							</button>
						</Link>
					</div>

					<div className="cr-card">
						<ul className="list-group">
							{topics.map(({ name, id, concepts }) => (
								<li key={id} className="list-group-item list-item">
									<span>{name}</span>
									<div className="question-container">
										{concepts.map((concept, index) => (
											<div
												key={concept.id}
												className="col-3"
												onMouseEnter={(e) => handleMouseEnter(e, concept)}
												onMouseLeave={(e) => handleMouseLeave(e, concept)}
											>
												<span>{textIdentifier['question'][lang]} {index + 1}</span>
												<span
													className={`chip ${getClassName(
														concept.topic_level
													)}`}
												>
													{concept.topic_level.replace(/^\w/, (c) =>
														c.toUpperCase()
													)}
												</span>
												<span>{index === concepts.length - 1 ? "" : ","}</span>
												{showPreview && concept.id === previewContent?.id && (
													<div
														className="preview-box"
														style={{
															position: "fixed",
															left: previewPosition.x,
															top: previewPosition.y,
															zIndex:1000000
														}}
														onClick={() => viewQuestion(previewContent)}
													>
														<span className="card-title">{textIdentifier['preview'][lang]}</span>

														<div className="cr-card">
															<div className="d-flex align-items-center">
																<span className="cr-question">
																{textIdentifier['question'][lang]} {index + 1}
																</span>
																<span
																	className={`chip ${getClassName(
																		concept.topic_level
																	)}`}
																>
																	{concept.topic_level.replace(/^\w/, (c) =>
																		c.toUpperCase()
																	)}
																</span>
															</div>
															<div
																className="cr-question-description"
																dangerouslySetInnerHTML={{
																	__html: previewContent?.question?.question,
																}}
															></div>
															<div
																className="cr-question-answerType"
																dangerouslySetInnerHTML={{
																	__html: previewContent?.question?.answer_type,
																}}
															>
															</div>
														</div>
													</div>
												)}
											</div>
										))}
									</div>
								</li>
							))}
						</ul>
					</div>
				</div>
			</Main>
		</>
	);
};

export default ViewSyllabus;
